import { render, staticRenderFns } from "./market-view.vue?vue&type=template&id=7275df3f&scoped=true&"
import script from "./market-view.vue?vue&type=script&lang=ts&"
export * from "./market-view.vue?vue&type=script&lang=ts&"
import style0 from "./market-view.vue?vue&type=style&index=0&id=7275df3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7275df3f",
  null
  
)

export default component.exports